<form [formGroup]="addPoolConsumptionSearch">
    <!-- {{addPoolConsumptionSearch.value| json}} -->
    <div style="display: flex; ">
        <label style="height: 23px;
    position: relative;
    top: 15px;
    margin-right: 25px;">Days to check</label>
        <div class="box">Next</div>
        <mat-form-field appearance="outline" class="depo">
            <input formControlName="next" matInput type="text" placeholder="Days"  >
        </mat-form-field>
        <span style="height: 22px;
    position: relative;
    top: 3px;
    margin: 10px;">---</span>

        <mat-form-field appearance="outline" class="depo">
            <input formControlName="day" matInput type="text" placeholder="Days" >
        </mat-form-field>
        <div class="box">Days</div>

    </div>
    <div>
         {{this.futuredate}} ---  {{this.currentdate}}
    </div>
    <div style=" align-items: baseline;">
      
        <mat-radio-group aria-label="Select an option" formControlName="optionControl" (change)="selecteddata($event)">
            
            <div class="revo">
                  <label style="    position: relative;
    top: -10px;">
            Time configuration
        </label>
            <mat-radio-button value="0">Per day:</mat-radio-button>
            <div formArrayName="startTime" *ngFor="let data of FormDatasearchData.controls; let i=index">
                <div [formGroupName]="i">
                    <div class="outer-flex-container">
                        <div class="inner-flex-container">
                            <vue-select class="select_width"
                                [class]=""
                                label="{{ 'label.placeholder.startTime' | translate | async }}"
                                formControlName="startTime" [required]="true" [options]="utcStartTimes"
                                [getOptionDisplay]="addUTCToTime.bind(this)"
                                [errorMatcher]="suppressErrorState"></vue-select>
                            <vue-select class="select_width"
                                label="{{ 'label.placeholder.endTime' | translate | async }}" formControlName="endTime"
                                [options]="utcEndTimes" [getOptionDisplay]="addUTCToTime.bind(this)" [required]="true"
                                [errorMatcher]="suppressErrorState"></vue-select>
                        </div>
                        <span class="crossButton" (click)="removedatafromSearchPool(i)">&cross;</span>
                    </div>
                    <span class="error" *ngIf=" getValidationcontrols(i).controls['endTime'].errors && (getValidationcontrols(i).controls['endTime'].touched
        && getValidationcontrols(i).controls['endTime'].dirty)"><small>{{'message.warning' | translate |
                            async}}</small> </span>
                </div>
            </div>
            </div>

            <!-- <div class="addExtracolumns">
                <button mat-button color="primary" (click)="Duplicatethedata()"><span style="font-size: 19px;">+</span>
                    &nbsp;{{'label.add_another_time_range' |
                    translate | async }}</button>
            </div> -->
            <div style="    width: 322px; position: relative; left: 184px; margin-top: -8px;">
                <mat-checkbox formControlName="allday" (change)="checkstatusallday($event)" >All Day</mat-checkbox><br>
                <small style="    position: relative;
    left: 11px;
    color: grey;
    font-family: sans-serif;">checks utilization for the selected time range seprately for each date in the date range.</small>
            </div>
            <div style="    
  
    width: 300px;
    position: relative;
    left: 111px;
    margin-top: 15px;
    ">

                <mat-radio-button value="1">Consecutive hourly interval:</mat-radio-button>
                <br>

                <vue-select style=" position: relative;
    left: 43px;" formControlName="Consecutive" label="{{ 'title.queue' | translate | async }}" [required]="true"></vue-select>
            </div>
        </mat-radio-group>


    </div>


    <div>
        <label>
            If Capacity utilization Is below*:
        </label>
        <mat-form-field appearance="outline" class="depo">
            <input formControlName="percentage" matInput type="text" placeholder="Days">
        </mat-form-field>
    </div>
</form>